"use client";

import React from "react";
import { SidebarFooter } from "./SidebarFooter";
import { MenuButton } from "./MenuButton";
import { Logo, Menu } from "@/app/[locale]/components";
import { motion, useCycle } from "framer-motion";
import Image from "next/image";
import { languages } from "@/app/constants";
import Language from "./Language";
import ContactIcon from "./ContactIcon";
import { NavLogo } from "../../logo/NavLogo";

const language = languages[languages.length - 1];
function MobileContainer({ children }: SidebarPropsType) {
  const [isOpen, toggleOpen] = useCycle(false, true);
  const [openLanguages, toggleOpenLanguages] = useCycle(false, true);

  return (
    <div className="fixed bg-primary z-[10000] top-0 start-0 end-0  h-max w-full">
      <motion.div
        initial={{ height: "10rem" }}
        variants={{
          open: {
            height: "100vh",
          },
          closed: {
            height: "10rem",
          },
        }}
        animate={isOpen ? "open" : "closed"}
        transition={{ duration: 0.2 }}
        className="  overflow-hidden"
      >
        <div className="h-[10rem]  bg-primary   relative">
          <div className="flex  items-center h-full relative container ">
            <NavLogo onClick={isOpen ? toggleOpen : undefined} open={isOpen} />
            <motion.div
              initial={{ insetInlineEnd: "43%" }}
              variants={{
                open: {
                  insetInlineEnd: 0,
                },
                closed: {
                  insetInlineEnd: "43%",
                },
              }}
              animate={isOpen ? "open" : "closed"}
              transition={{ duration: 0.2 }}
              className=" absolute  "
            >
              <MenuButton open={isOpen} toggleOpen={() => toggleOpen()} />
            </motion.div>
          </div>

          <motion.div
            initial={{ width: "20rem" }}
            variants={{
              open: {
                width: "0",
                paddingInlineEnd: "0px",
              },
              closed: {
                width: "20rem",
              },
              openLanguages: {
                width: "auto",
                minWidth: "52%",
              },
            }}
            animate={
              isOpen ? "open" : openLanguages ? "openLanguages" : "closed"
            }
            transition={{ duration: 0.2 }}
            className=" bg-secondary max-w-[80%] pe-[6rem] overflow-hidden absolute h-full end-0 top-0 "
          >
            <div className="flex relative  items-center gap-3 py-4 w-max px-10 h-full ml-auto">
              {" "}
              <button className={``} onClick={() => toggleOpenLanguages()}>
                <Image
                  width={11.6}
                  height={11.6}
                  className={`w-8 m-auto transition-all   ease-in-out duration-200 ${
                    openLanguages
                      ? " rotate-90  rtl:-rotate-90"
                      : " -rotate-90 rtl:rotate-90"
                  }`}
                  src="/icons/arrowTop.svg"
                  alt="Toggle language options"
                />
              </button>
              <div className="flex gap-[2.25rem] pe-[30px] items-center">
                <motion.div
                  initial={{ transform: "translateX(-1000px)" }}
                  variants={{
                    openLanguages: {
                      transform: "translateX(0)",
                      width: "auto",
                    },
                    closedLanguages: {
                      transform: "translateX(-1000px)",
                      width: 0,
                    },
                  }}
                  animate={openLanguages ? "openLanguages" : "closedLanguages"}
                  transition={{ duration: 0.3 }}
                  className="flex gap-5 items-center  overflow-hidden"
                >
                  {languages.slice(0, languages.length - 1).map((language) => (
                    <Language {...language} key={language.key} />
                  ))}
                </motion.div>
                <Language {...language} key={language.key} />
              </div>
            </div>
          </motion.div>
          {!isOpen && (
            <motion.div
              transition={{ duration: 0.2 }}
              className="absolute  flex  flex-row-reverse top-0 -end-3 h-[10rem]  items-center "
            >
              {" "}
              <ContactIcon />
            </motion.div>
          )}
        </div>
        <div style={{ height: "calc(100vh - 8rem)" }} className="flex flex-col">
          <div className="h-[60%] flex items-center overflow-hidden justify-center mt-11 flex-1">
            <Menu menuOnClick={toggleOpen} />
          </div>
          <SidebarFooter menuOnClick={() => toggleOpen()} />
        </div>
      </motion.div>
    </div>
  );
}
export default MobileContainer;

export type SidebarPropsType = {
  children?: JSX.Element;
};
